import { render, staticRenderFns } from "./SizeRichText.vue?vue&type=template&id=7ba5f621&"
import script from "./SizeRichText.vue?vue&type=script&lang=js&"
export * from "./SizeRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports